import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ModalBody, ModalHeader } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { VrrModal } from '../../shared_components';
import BrandForm from './brand_form';
import { checkValidation } from './services';
import { addNewBrand, getBrandComplete } from '../../../redux/app/appActions';
import { initializePreviews } from '../../../redux/app/appSlice';
import { TBrand, TBrandModal } from './types';

const BrandModal: React.FC<TBrandModal> = ({ isOpen, onCancelAction }) => {
  const { t } = useTranslation();
  const dispatch: any = useDispatch();
  const isComplete = useSelector(getBrandComplete);

  const [brand, setBrand] = useState<TBrand | undefined>(undefined);

  const onCancel = () => {
    setBrand(undefined);
    dispatch(initializePreviews());
    if (onCancelAction) onCancelAction();
  };

  useEffect(() => {
    if (isComplete) {
      onCancel();
    }
  }, [isComplete]);

  const onSubmit = () => {
    if (brand) {
      dispatch(
        addNewBrand({
          ...brand
        })
      );
    }
  };

  const onChangeBrand = (newBrand: TBrand) => {
    setBrand(newBrand);
  };

  return (
    <VrrModal
      className="brand-modal"
      isOpen={isOpen}
      modalHeader={
        <ModalHeader className="creative-modal-header">
          <span>
            <i className="tim-icons icon-zoom-split circle-icon" />
          </span>
          <span className="creative-modal-title">
            {t('main_navbar.brand_modal.title')}
          </span>
        </ModalHeader>
      }
      modalBody={
        <ModalBody className="brand-modal-modal-body">
          <BrandForm
            brand={brand}
            onChangeAction={(newBrand: TBrand) => {
              onChangeBrand(newBrand);
            }}
          />
        </ModalBody>
      }
      toggleModal={onCancel}
      toggleValidation={onSubmit}
      {...(isOpen && { enabledValidationButton: checkValidation(brand) })}
      scrollable
    />
  );
};

export default BrandModal;
